export const EXPERT_POINTS_NOTIFICATIONS_CATCH_UP_EVENT = 'expert-points-notifications:catch-up'

export const requestExpertPointsNotificationsCatchUp = () => {
  if (typeof window === 'undefined') return

  window.dispatchEvent(new Event(EXPERT_POINTS_NOTIFICATIONS_CATCH_UP_EVENT))
}
